export default "__VITE_ASSET__D8oB$zqk__"